import { Injectable } from '@angular/core';
import * as firebase from 'firebase/compat/app';

import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/compat/firestore';
import * as firebaseui from './../firebaseuies/npm__es.js';
import { Observable, Observer, combineLatest, BehaviorSubject, Subscriber } from 'rxjs';
import { Firestore,addDoc,doc ,setDoc, getDoc, deleteDoc,updateDoc, docData, query, Query, collectionData, collectionGroup, where, collection} from '@angular/fire/firestore';
import { FirebaseApp } from '@angular/fire/compat';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { sendEmailVerification, ActionCodeSettings } from 'firebase/auth';
import { TipoAccesoService } from './services/tipo-acceso.service';
import { take } from 'rxjs/operators';

  enum AUTH_STATUS {
    AUTHENTICATED,
    UNAUTHENTICATED,
    PENDING_REGISTER,
    PENDING_AUTHORIZATION
  }
@Injectable({
  providedIn: 'root'
})
export class AuthFirebaseService {

  public AuthStatus = AUTH_STATUS;
  ui: any;

  adminData:any;
  usersEntidad: any[];

  public userEmail: string | null = null;

  private adminDataSubject = new BehaviorSubject<any>(null);

  public pendingUser: string | null = null;

  constructor(protected angularFire: FirebaseApp, private firestore: Firestore, private tipoAccesoService: TipoAccesoService) {
    console.log("Inicializamos FIREBASE")
    this.ui = new firebaseui.auth.AuthUI(angularFire.auth());
  }

  private getUserById(userId: string): Observable<any> {
    const userRef = doc(this.firestore, `users/${userId}`);
    return docData(userRef, { idField: 'id' });
  }

  getAdminData(): Observable<any> {
    if (this.adminData != null) {
      this.adminDataSubject.next(this.adminData);
    }

    return this.adminDataSubject.asObservable();
  }

  closeSession() {
    this.angularFire.auth().signOut();
    this.adminData = null;
    this.adminDataSubject.next(null);
  }

  isAuthenticated():Observable<AUTH_STATUS>{
    return new Observable((observer) => {

      if(this.adminData != null){
        if (this.pendingUser) {
          observer.next(AUTH_STATUS.PENDING_AUTHORIZATION);
        } else {
          observer.next(AUTH_STATUS.AUTHENTICATED);
        }
      }else{
        this.angularFire.auth().onAuthStateChanged((user) => {

          if(user == null) {
             this.adminData = null;
             this.userEmail = null;
             this.pendingUser = null;
             this.adminDataSubject.next(null);
             observer.next(AUTH_STATUS.UNAUTHENTICATED);
            } else if (this.adminData == null) {
              this.userEmail = user.email;
              this.updateAdminData().then(result => {

              if (result) {

                // Comprobar si es una entidad COMPANY de tamaño xs
                if (
                  this.adminData?.entidad?.type === 'COMPANY' &&
                  this.adminData?.entidad?.size === 'company_xs'
                ) {
                  this.getUserById(user.uid).pipe(take(1)).subscribe({
                    next: (userData) => {

                      if (userData?.reaCueAuthorized === 'AUTHORIZED') {
                        this.pendingUser = null;
                        observer.next(AUTH_STATUS.AUTHENTICATED);
                      } else {
                        this.pendingUser = userData.id
                        observer.next(AUTH_STATUS.PENDING_AUTHORIZATION);
                      }

                    },
                    error: (error) => {
                      console.error('Error al obtener los datos del usuario:', error);
                      observer.error(error);
                    }
                  });

                } else {
                  observer.next(AUTH_STATUS.AUTHENTICATED);
                }

              } else {
                observer.next(AUTH_STATUS.PENDING_REGISTER);
              }

            }).catch(error => {
              console.error('Error al actualizar los datos del administrador:', error);
              observer.error(error);
            });

          } else {
            observer.next(AUTH_STATUS.UNAUTHENTICATED);
          }

        });
      }

    });
  }

  updateAdminData(): Promise<boolean> {
    const functions = getFunctions(this.angularFire,'europe-southwest1');

    const requestGetAdminData = httpsCallable(functions, 'getAdminData');

    return requestGetAdminData()
      .then((resultado: any) => {
        const adminUser = resultado.data;

        if (adminUser) {
          this.adminData = adminUser;
          this.adminDataSubject.next(this.adminData);

          if (this.adminData.entidad) {
            this.updateUsuariosEntidad();
          }

          if (
            this.adminData.scope === 'ALL' &&
            this.adminData.role === 'ROOT'
          ) {
            this.superAdministratorLoginNotif();
          }

          return true;
        } else {
          this.adminData = null;
          this.adminDataSubject.next(null);
          return false;
        }
      })
      .catch(error => {
        console.error('Error en getAdminData:', error);
        this.adminData = null;
        this.adminDataSubject.next(null);
        return false;
      });
  }

  updateUsuariosEntidad(){
    collectionData(query(collection(this.firestore,`/users`),where('entidad','==',this.adminData.scope)),{idField:'id'}).subscribe(usuarios => {
      this.usersEntidad = usuarios;
    },error => {
      console.log(error)
      console.log('Ha ocurrido un error al obtener los usuarios');
    })
  }

  initAuthUi(container:string):Observable<any>{

    return new Observable((observer) => {


      this.ui.start(container, {
        signInOptions: [
          firebase.default.auth.EmailAuthProvider.PROVIDER_ID,
          firebase.default.auth.GoogleAuthProvider.PROVIDER_ID
        ],
        callbacks: {
          signInSuccessWithAuthResult: (authResult, redirectUrl) => {
            console.log(authResult);
            const currentUser = firebase.default.auth().currentUser;

            // Enviar correo de verificación si es un nuevo usuario
            if (authResult.additionalUserInfo && authResult.additionalUserInfo.isNewUser && currentUser) {
              // Obtener la URL base actual para el enlace de verificación
              const baseUrl = this.tipoAccesoService.getCurrentBaseUrl();
              const actionCodeSettings: ActionCodeSettings = {
                url: `${baseUrl}auth/login`,
                handleCodeInApp: true
              };

              sendEmailVerification(currentUser, actionCodeSettings)
                .then(() => {
                  console.log('Email de verificación enviado a:', currentUser.email);
                })
                .catch((error) => {
                  console.error('Error al enviar email de verificación:', error);
                });
            }

            observer.next(currentUser);

            return false;
          },
          signInFailure: (error) => {
            console.log(`Error al logarse`);
            observer.error(error);
          }

        },
        // Other config options...
      });
    })

  }

    async superAdministratorLoginNotif(){
      const functions = getFunctions(this.angularFire,'europe-southwest1');

      const notifSuperAdministratorLogin = httpsCallable(functions, 'superAdministratorLogin');
      notifSuperAdministratorLogin();
    }

}
